import { NgModule } from '@angular/core';

import { DialogZoneInfoComponent } from './dialog-zone-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { CoreUiModule, DialogLayoutModule } from '@ridango/components';

@NgModule({
    imports: [CommonModule, DialogLayoutModule, TranslateModule, CoreUiModule],
    exports: [DialogZoneInfoComponent],
    declarations: [DialogZoneInfoComponent],
    providers: []
})
export class DialogZoneInfoModule {}
